import React from "react";
import PropTypes from "prop-types";
import { Badge, Divider, Space } from "antd";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";

import themeColor from "../../lib/style/theme";
import generalTranslations from "../../lib/translations";

import IncompleteConfig from "../IncompleteConfig";

const { Ribbon } = Badge;

export default function EnginePlayoutElement({ handleClick, label, outputData, incomplete, data }) {
  const noIncomplete = !incomplete || (incomplete && incomplete.length === 0);
  const parsedData = data && Object.entries(data).filter(([key]) => key !== "enabled");
  const { formatMessage } = useIntl();

  return (
    <Ribbon
      text={<IncompleteConfig incomplete={incomplete} color="#FFFFFF" />}
      color={noIncomplete ? themeColor.green : themeColor.orange}
    >
      <StyledContainer onClick={handleClick}>
        <StyledAsideType>{label}</StyledAsideType>
        <StyledBoldText>{outputData?.name}</StyledBoldText>
        <StyledSpace align="center" split={<Divider type="vertical" />}>
          {data &&
            parsedData.map((element) => (
              <span key={element[0]}>
                <StyledText>
                  {generalTranslations[element[0]] ? formatMessage(generalTranslations[element[0]]) : element[0]}:
                </StyledText>
                <StyledBoldText>
                  {element[1] === false ? (
                    <FormattedMessage id="general.disabled" defaultMessage="Disabled" />
                  ) : (
                    element[1]
                  )}
                </StyledBoldText>
              </span>
            ))}
        </StyledSpace>
      </StyledContainer>
    </Ribbon>
  );
}

const StyledText = styled.span`
  margin-right: 5px;
`;

const StyledBoldText = styled.span`
  font-weight: bold;
`;

const StyledSpace = styled(Space)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 35px;
  overflow: auto;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  height: 115px;
  margin: 0 0 15px 30px;
  padding: 10px;
  border: 1px solid ${themeColor.grayBorder};
  border-radius: 2px;
  transition: all 0.3s;

  &:hover {
    cursor: pointer;
    box-shadow:
      0 1px 2px -2px rgba(0, 0, 0, 0.16),
      0 3px 6px 0 rgba(0, 0, 0, 0.12),
      0 5px 12px 4px rgba(0, 0, 0, 0.09);
  }
`;

const StyledAsideType = styled.span`
  font: bold 11px Sans-Serif;
  letter-spacing: 1px;
  text-transform: uppercase;
  background: ${themeColor.orange};
  color: #fff;
  padding: 5px;
  line-height: 24px;
  position: absolute;
  top: 114px;
  left: -1px;
  transform-origin: 0 0;
  transform: rotate(270deg);
  width: 115px;
  text-align: center;
  border: 1px solid ${themeColor.grayBorder};
  border-radius: 2px;
`;

EnginePlayoutElement.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
